// src/components/AuthHashRedirect.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const cleanPath = (value = "") => {
  const path = String(value || "").trim().replace(/\/+$/, "");
  return path || "/";
};

const readParams = (value = "") =>
  new URLSearchParams(String(value || "").replace(/^[?#]/, ""));

export default function AuthHashRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = cleanPath(location.pathname);
    const query = readParams(location.search);
    const fragment = readParams(location.hash);

    const authType = String(
      fragment.get("type") || query.get("type") || "",
    )
      .trim()
      .toLowerCase();

    // A normal UniAir registration/promoter code is not a Supabase PKCE code.
    // Only genuine password-recovery links may be redirected here.
    const isPasswordRecovery = authType === "recovery";

    if (!isPasswordRecovery || pathname === "/reset-password") {
      return;
    }

    navigate(
      {
        pathname: "/reset-password",
        search: location.search,
        hash: location.hash,
      },
      { replace: true },
    );
  }, [
    location.hash,
    location.pathname,
    location.search,
    navigate,
  ]);

  return null;
}
